import $ from 'jquery';
export class FormFileUpload {
    constructor() {
        this.selector = '.fileupload';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            const $fileuploadFilename = $(element).find('.fileupload-filename');
            $(element).find('input').on('change', (event) => {
                const filename = event.target.files[0].name;
                $fileuploadFilename.text(filename);
            });
        });
    }
}
